var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImaage(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "imaage",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_138",
    "data-name": "Rectangle 138",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_370",
    "data-name": "Group 370",
    transform: "translate(-736.607 -453.521)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M321.986,131.971A1.986,1.986,0,1,0,320,129.986,1.986,1.986,0,0,0,321.986,131.971Z",
    transform: "translate(431.521 332.168)",
    fill: "#e62237"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M49.375,64H33.158A1.162,1.162,0,0,0,32,65.171V78.715a1.162,1.162,0,0,0,1.158,1.171H49.375a1.162,1.162,0,0,0,1.158-1.171V65.171A1.162,1.162,0,0,0,49.375,64Zm-4.265,8.178a.71.71,0,0,0-.53-.256.817.817,0,0,0-.53.236l-.774.654a.776.776,0,0,1-.476.194.684.684,0,0,1-.455-.17c-.041-.037-.116-.108-.178-.17l-2.226-2.408a.912.912,0,0,0-.691-.31.94.94,0,0,0-.695.323l-5.233,6.313V65.808a.545.545,0,0,1,.542-.484h14.8a.525.525,0,0,1,.534.5l.012,10.772Z",
    transform: "translate(707.608 393.521)",
    fill: "#e62237"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImaage);
export default __webpack_public_path__ + "static/media/imaage.8d88a8758c06b0b32660bb3569630b3e.svg";
export { ForwardRef as ReactComponent };